var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ma-0 pa-0 iconContainer"},[_c('v-icon',{attrs:{"small":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.getIcon(_vm.params)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }